import * as actionCreatorFactory from "typescript-fsa";

import { PaginationResult, HttpStateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { DeliveryNormalisedEntities, Filters } from "../models";

export type DeliveriesResult = NormalisedResult<string[], DeliveryNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

export const requestDeliveriesIndex = actionCreator<{}>(actionTypes.INDEX_REQUEST);
export const deliveriesIndexSuccess = actionCreator<[PaginationResult, DeliveriesResult]>(
    actionTypes.INDEX_SUCCESS,
);
export const deliveriesIndexFailure = actionCreator<HttpStateError>(actionTypes.INDEX_FAILURE);

export const requestDeliveriesShow = actionCreator<{}>(actionTypes.SHOW_REQUEST);
export const deliveriesShowSuccess = actionCreator<NormalisedResult<string, DeliveryNormalisedEntities>>(
    actionTypes.SHOW_SUCCESS,
);
export const deliveriesShowFailure = actionCreator<HttpStateError>(actionTypes.SHOW_FAILURE);

export const resetFilters = actionCreator<{}>(actionTypes.RESET_FILTERS);
export const setFilters = actionCreator<Filters>(actionTypes.SET_FILTERS);

// Need to override the action to prevent a weird bug: https://github.com/Microsoft/TypeScript/issues/18371
interface Action<P> {
    readonly type: string;
    payload: P;
    error?: boolean;
}

export type DeliveriesAction = Action<{}> | Action<DeliveriesResult> |
    Action<NormalisedResult<string, DeliveryNormalisedEntities>> |
    Action<[PaginationResult, DeliveryNormalisedEntities]> | Action<HttpStateError> |
    Action<Filters>;
